export const convertHexColorToRgbWithOpacity = (
  hexColor: string,
  opacity: number
): string => {
  const rgb = /^#(..)(..)(..)$/.exec(hexColor)
  if (!rgb) {
    return hexColor
  }
  return `rgba(${Number.parseInt(rgb[1]!, 16)}, ${Number.parseInt(rgb[2]!, 16)}, ${Number.parseInt(rgb[3]!, 16)}, ${opacity})`
}
